import { render, staticRenderFns } from "./SymbolsChipsList.vue?vue&type=template&id=48187c4e&scoped=true"
import script from "./SymbolsChipsList.vue?vue&type=script&lang=js"
export * from "./SymbolsChipsList.vue?vue&type=script&lang=js"
import style0 from "./SymbolsChipsList.vue?vue&type=style&index=0&id=48187c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48187c4e",
  null
  
)

export default component.exports